import snackbar from 'config/snackbar'

const namespaced = true

const state = {
  snackbar: snackbar
}

const getters = {

  /**
   * Get snackbar configuration.
   *
   * @return {Object}
   */
  getDefaultConfig: state => state.snackbar
}

const actions = {

  /**
   * Show snackbar.
   *
   * @param {Object} context → vm
   * @param {Object} text    → snackbar text
   */
  show: function show (context, payload) {
    context.commit('show', payload)
  },

  /**
   * Hide snackbar.
   *
   * @param {Object} commit
   */
  hide: function hide (commit) {
    commit('hide')
  }
}

const mutations = {

  /**
   * Show snackbar.
   *
   * @param {Object} state → store payload
   */
  show: function show (state, payload) {
    state.snackbar.display = true
    state.snackbar.text = payload.text || payload
    state.snackbar.y = payload.y || state.snackbar.y
    state.snackbar.x = payload.x || state.snackbar.x
    state.snackbar.mode = payload.mode || state.snackbar.mode
    state.snackbar.timeout = payload.timeout || state.snackbar.timeout
    state.snackbar.text = payload.text || state.snackbar.text
    state.snackbar.color = payload.color || state.snackbar.color
    state.snackbar.buttonColor = payload.buttonColor || state.snackbar.buttonColor
    state.snackbar.buttonText = payload.buttonText || state.snackbar.buttonText
    state.snackbar.showButton = typeof payload.showButton !== 'undefined' ? payload.showButton : state.snackbar.showButton
    state.snackbar.flat = typeof payload.flat !== 'undefined' ? payload.flat : state.snackbar.showButton
  },

  /**
   * Hide snackbar.
   *
   * @param {Object} state → store payload
   */
  hide: function hide (state) {
    state.snackbar.display = false
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/snackbar.js